import styles from "../../styles/About.module.scss";

const InputComponent = ({ placeholder, onchange, type }) => {
  return <input className={styles.input} placeholder={placeholder} onChange={(e) => onchange(e)} type={type} />;
};

export default InputComponent;
